import React from 'react';
import Skeleton from "react-loading-skeleton";
import '../Css/homeSkeleton.css';

const RightSkeleton = () => {
  return (
    <div className='homeSkeleton'>
      <div className='mainHomeSkeleton'>
        <div className='restaurantSkeleton'>
              <div className='skeletonPlusReserver'>
                <div className='row'>
                  <div className='col-md-6'>
                    <Skeleton height="100px" width="100%" />
                  </div>
                  <div className='col-md-6'>
                    <Skeleton height="20px" width="40%" />
                    <Skeleton height="20px" className='mt-2' width="100%" />
                    <Skeleton height="30px" className='mt-3' width="100%" />
                  </div>
                </div>
              </div>

        </div>
        <div className='restaurantSkeleton'>
              <div className='skeletonPlusReserver'>
                <div className='row'>
                  <div className='col-md-6'>
                    <Skeleton height="100px" width="100%" />
                  </div>
                  <div className='col-md-6'>
                    <Skeleton height="20px" width="40%" />
                    <Skeleton height="20px" className='mt-2' width="100%" />
                    <Skeleton height="30px" className='mt-3' width="100%" />
                  </div>
                </div>
              </div>

        </div>
        
      </div>
    </div>
  );
}

export default RightSkeleton